const comHeader = (() => {

  let body = document.querySelector('body');
  let header = document.getElementById('jsHeader');
  const pageTop = document.getElementById('pageTop');

  if (header != null) {

    if (pageTop) {
      const jsSecMain = document.getElementById('jsSecMain');
      ScrollTrigger.create({
        trigger: jsSecMain,
        start: 'top top',
        endTrigger: 'body',
        toggleClass: { targets: header, className: "scroll" },
        // onEnter: () => {
        //   console.log("enter");
        //   header.classList.add('scroll')
        // },
        // once: true,
        // markers: true,
      });
    }

  }


})();
export default comHeader;